import { createReducer, on } from '@ngrx/store';
import * as FeatureFlagsActions from './feature-flags.actions';

export interface FeatureFlagsState {
  featureFlags: any;
  loading: boolean;
  error: any;
}

export const initialState: FeatureFlagsState = {
  featureFlags: null,
  loading: false,
  error: null,
};

export const featureFlagsReducer = createReducer(
  initialState,
  on(FeatureFlagsActions.loadFeatureFlags, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FeatureFlagsActions.loadFeatureFlagsSuccess, (state, { featureFlags }) => ({
    ...state,
    featureFlags,
    loading: false,
    error: null,
  })),
  on(FeatureFlagsActions.loadFeatureFlagsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
